import { Outlet } from "react-router-dom";
import TopNav from "../Menus/TopNav";
import SideNav from "../Menus/SideNav";
import { useLayoutStore } from "../../context";
import { motion } from "framer-motion";

export default function AuthLayout() {
  const isSideNavOpen = useLayoutStore((state) => state.isSideNavOpen);

  return (
    <div className="flex h-screen flex-col">
      <TopNav />
      <div className="flex flex-1 overflow-x-hidden bg-white">
        <SideNav />
        <motion.div
          animate={{ marginLeft: isSideNavOpen ? "20rem" : "0rem" }}
          transition={{ type: "spring", stiffness: 95, damping: 20 }}
          className={`mt-16 flex-1 overflow-auto max-w-full`}
        >
          <Outlet />
        </motion.div>
      </div>
    </div>
  );
}
